import { useCallback } from "react";
import { fetchDownloadUrl, openDownloadUrl } from "./downloadPageServices";

export default function useDownloadPageModel() {
    const openDownloadLink = useCallback(async () => {
        const url = await fetchDownloadUrl();
        openDownloadUrl(url);
    }, []);

    return {
        openDownloadLink,
    };
}
